<template>
  <div
    class="pg-read-text-edit-style"
    :class="{
      'pg-read-text-edit-style__default': type === 'default',
      'pg-read-text-edit-style__info': type === 'info',
      'pg-read-text-edit-style__white': type === 'white',
    }"
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave"
  >
    <PgReadText
      ref="readRef"
      :value="transfromValue"
      v-bind="$attrs"
      :type="formatType"
      :style="contentStyle"
      >{{ transfromValue }}</PgReadText
    >
    <Tooltip
      placement="top"
      ref="tooltipRef"
      :content="tooltipContent"
      v-if="!!showTooltip"
    ></Tooltip>
  </div>
</template>

<script setup>
import PgReadText from './read-text.vue'
import { computed, ref, nextTick } from 'vue'
import { Tooltip } from 'element-ui'

const props = defineProps({
  value: [String, Number, Boolean],
  //[{ "label": "启用", "value": true }, { "label": "停用", "value": false }]
  ruleArray: Array,
  // 支持default/info/white
  type: String,
  formatType: String,
  contentStyle: Object,
})

const transfromValue = computed(() => {
  if (props.ruleArray && props.ruleArray.length > 0) {
    const rule = props.ruleArray.find((item) => item.value === props.value)
    if (rule) {
      return rule.label
    }
  }
  return props.value
})

const readRef = ref(null)
const showTooltip = ref(false)
const tooltipContent = ref('')
const tooltipRef = ref(null)
const onMouseenter = (event) => {
  if (event.target.clientWidth < event.target.scrollWidth) {
    tooltipContent.value = readRef.value.$el.innerHTML
    if (!tooltipRef.value) {
      showTooltip.value = true
      nextTick(() => {
        if (tooltipRef.value) {
          tooltipRef.value.referenceElm = event.target
          tooltipRef.value.doDestroy()
          tooltipRef.value.show()
        }
      })
    } else {
      tooltipRef.value.show()
    }
  }
}
const onMouseleave = () => {
  if (tooltipRef.value) {
    tooltipRef.value.hide()
  }
}
</script>
<style lang="scss">
.pg-read-text-edit-style {
  border-radius: 2px;
  background-color: var(--color-primary-light-1);
  border: 1px solid var(--color-primary-light-2);
  cursor: text;
  padding: 0 4px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  position: relative;
}

.pg-read-text-edit-style.pg-read-text-edit-style__default {
  background: none;
  padding: 0;
  border-radius: 0;
  border: none;
}
.pg-read-text-edit-style.pg-read-text-edit-style__info {
  background-color: var(--color-background-3);
  border: none;
  line-height: 34px;
}
.pg-read-text-edit-style.pg-read-text-edit-style__white {
  background-color: var(--color-white);
  border: none;
  line-height: 34px;
}
</style>
